export const COUNTRIES = [
  'India',
  'United States',
  'United Kingdom',
  'Canada',
  'Australia',
  'Germany',
  'France',
  'Singapore',
  'United Arab Emirates',
  'Japan',
  'China',
  'South Korea',
  'Thailand',
  'Malaysia',
  'Indonesia',
  'Nepal',
  'Sri Lanka',
  'Bangladesh',
  'Pakistan',
  'Other',
];

export const INDIAN_CITIES = [
  'Mumbai',
  'Delhi',
  'Bangalore',
  'Hyderabad',
  'Chennai',
  'Kolkata',
  'Pune',
  'Ahmedabad',
  'Jaipur',
  'Surat',
  'Lucknow',
  'Kanpur',
  'Nagpur',
  'Indore',
  'Thane',
  'Bhopal',
  'Visakhapatnam',
  'Patna',
  'Vadodara',
  'Ghaziabad',
  'Ludhiana',
  'Agra',
  'Nashik',
  'Faridabad',
  'Meerut',
  'Rajkot',
  'Varanasi',
  'Srinagar',
  'Amritsar',
  'Chandigarh',
  'Coimbatore',
  'Kochi',
  'Goa',
  'Shimla',
  'Manali',
  'Dehradun',
  'Nainital',
  'Rishikesh',
  'Haridwar',
  'Mussoorie',
];

export const fetchLocationByPinCode = async (pinCode) => {
  try {
    const response = await fetch(`https://api.postalpincode.in/pincode/${pinCode}`);
    const data = await response.json();

    if (data[0]?.Status === 'Success' && data[0].PostOffice?.length > 0) {
      const postOffice = data[0].PostOffice[0];
      return {
        city: postOffice.District || postOffice.Name,
        country: postOffice.Country || 'India',
      };
    }
    return null;
  } catch {
    return null;
  }
};
